import React, { useEffect, useState } from 'react';
import LocaleContext from './LocaleContext';
import { IntlProvider } from 'react-intl';
import en_US from '../locales/en';
import zh_CN from '../locales/zh';

const LocaleProvider = ({ children }) => {
  // Attempt to retrieve the locale from the URL or local storage, defaulting to 'en'
  const getInitialLocale = () => {
    if (typeof window !== 'undefined') {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const languageFromUrl = urlParams.get('language');
      
      if (languageFromUrl) {
        return languageFromUrl;
      }
    }

    return window.localStorage.getItem('locale') || 'en';
  };

  const [locale, setLocale] = useState(getInitialLocale());

  const changeLocale = (newLocale) => {
    setLocale(newLocale);
    window.localStorage.setItem('locale', newLocale);
  };

  const getMessages = (message) => {
    let returnMsg;
    switch (message) {
      case "zh":
        returnMsg = zh_CN;
        break;
      case "en":
        returnMsg = en_US;
        break;
      default:
        returnMsg = en_US;
        break;
    }
    return returnMsg;
  }

  // Effect to sync locale change with URL query parameters, if needed
  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const languageFromUrl = urlParams.get('language');

    if (languageFromUrl && languageFromUrl !== locale) {
      setLocale(languageFromUrl);
    }
  }, [locale]);

  return (
    <LocaleContext.Provider value={{ locale, changeLocale }}>
      <IntlProvider locale={locale} messages={getMessages(locale)}>
        {children}
      </IntlProvider>
    </LocaleContext.Provider>
  );
};

export default LocaleProvider;
